var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"4"}},[_c('v-progress-linear',{attrs:{"indeterminate":true,"color":"secondary"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }